import { API_URL } from '../constants/config'
import { query } from './utilities'
import { SetApplicationRole } from '../actions/applicationRoleActions'
import {
  WaitOnProceedEstimateSubmission,
  OnProceedWithEstimateSubmission,
} from '../actions/proceedEstimateActions'
import { applicationRoles } from '../constants/actionTypes'

export const OnProceedWithEstimate = (
  opportunityId,
  estimateId,
  dispatch,
  history
) => {
  let inputDetails = {
    isIndicative: true,
    quoteId: estimateId,
  }
  dispatch(WaitOnProceedEstimateSubmission())
  query(
    `${API_URL}/opportunity/${opportunityId}/proposal/indicative/${global.config.brand}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(inputDetails),
    }
  ).then(
    (data) => {
      dispatch(SetApplicationRole(applicationRoles.USER_ACCEPTED_ESTIMATE))
      dispatch(OnProceedWithEstimateSubmission(true, data))
      history.push('/estimates/' + inputDetails.quoteId + '/proceed')
    },
    (error) => {
      dispatch(OnProceedWithEstimateSubmission(false, error.replace('400', '')))
    }
  )
}
